{
  "placeholder": {
    "title": "作品繳交",
    "description": "作品繳交功能尚未開放。"
  }
}
